import {Exclude, Expose, instanceToPlain, plainToInstance, Transform} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";
import {getDatabaseCodeTransformer} from "./transfomers/transformers";
import {InvoiceAccountType, toInvoiceAccountType} from "./invoice-account-type";
import {SiteType, toSiteType } from "./site-type";

export const InvoiceAccountValidator = t.intersection([
  t.type({
    id: t.string,
    name: t.string,
    type: t.string,
    regionId: t.string,
  }),
  t.partial({
    trailerCompanyId: t.string,
    operatorId: t.string,
    containerId: t.string,
    routeId: t.string,
    siteId: t.string,
    waterTypeId: t.string,
    serviceTypeId: t.string,
    serviceTypeCat: t.string,
    siteType: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export const InvoiceAccountArrayValidator = t.array(
  InvoiceAccountValidator
);

export type InvoiceAccount = t.TypeOf<typeof InvoiceAccountValidator>;
export type InvoiceAccountArray = t.TypeOf<typeof InvoiceAccountArrayValidator>;

@Exclude()
export class InvoiceAccountEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  name!: string;

  @Expose()
  @Transform(getDatabaseCodeTransformer(toInvoiceAccountType))
  type!: InvoiceAccountType

  @Expose()
  regionId!: string

  @Expose()
  trailerCompanyId?: string

  @Expose()
  operatorId?: string

  @Expose()
  containerId?: string

  @Expose()
  routeId?: string

  @Expose()
  siteId?: string

  @Expose({name: "waterTypeId"})
  freightTypeId?: string

  @Expose()
  serviceTypeId?: string

  @Expose()
  serviceTypeCat?: string

  @Expose()
  @Transform(getDatabaseCodeTransformer(toSiteType))
  siteType?: SiteType

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  readonly entityType = 'INVACCTLOOKUP';

  get displayName(): Readonly<string> {
    return this.name;
  }

  /**
   * Constructor for InvoiceAccount. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: InvoiceAccount): InvoiceAccountEntity {
    return plainToInstance(InvoiceAccountEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<InvoiceAccount> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(InvoiceAccountValidator, object);
  }

  asTypeValue(): InvoiceAccount {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(InvoiceAccountValidator, object);
  }
}
